<template>
  <div
    class="comp"
    :class="{ 'has-mouse': hasMouse }"
    @touchstart="hasMouse = false"
  >
    <Flipbook
      class="flipbook"
      :class="{ spine: page > 1 && page < pages.length - 1 }"
      :pages="pages"
      :pagesHiRes="pagesHiRes"
      :startPage="pageNum"
      v-slot="flipbook"
      :centering="true"
      ref="flipbook"
      @zoom-start="onZoomStart"
      @flip-left-start="onFlipStart"
      @flip-right-start="onFlipStart"
      @flip-left-end="onFlipStart"
      @flip-right-end="onFlipStart"
    >
      <!--     
      @flip-left-end="onFlipLeftEnd"
     
      @flip-right-end="onFlipRightEnd" -->
      <div class="action-bar">
        <left-icon
          class="btn left"
          v-if="flipbook.page != 1"
          :class="{ disabled: !flipbook.canFlipLeft }"
          @click="flipbook.flipLeft"
        />

        <plus-icon
          class="btn plus"
          :class="{ disabled: !flipbook.canZoomIn }"
          @click="flipbook.zoomIn"
        />
        <span class="page-num">
          Page {{ flipbook.page }} of {{ flipbook.numPages }}
        </span>
        <minus-icon
          class="btn minus"
          :class="{ disabled: !flipbook.canZoomOut }"
          @click="flipbook.zoomOut"
        />
        <right-icon
          class="btn right"
          v-if="flipbook.numPages - 1 != flipbook.page"
          :class="{ disabled: !flipbook.canFlipRight }"
          @click="flipbook.flipRight"
        />
        <span v-if="value.downloadablePDF" class="seperator">|</span>
        <a
          v-if="value.downloadablePDF"
          class="download"
          :href="value.downloadablePDF.imageURL + '&download=true'"
        >
          <download-icon
            title="Download this Booklet"
            class="btn"
            :class="{ disabled: !flipbook.canFlipRight }"
          />
          Download
        </a>
      </div>
    </Flipbook>
  </div>
</template>

<script>
import "vue-material-design-icons/styles.css";
import LeftIcon from "vue-material-design-icons/ChevronLeftCircle";
import RightIcon from "vue-material-design-icons/ChevronRightCircle";
import PlusIcon from "vue-material-design-icons/PlusCircle";
import DownloadIcon from "vue-material-design-icons/DownloadCircle";
import MinusIcon from "vue-material-design-icons/MinusCircle";
import Flipbook from "flipbook-vue";

export default {
  props: { value: Object },
  name: "flipbook",
  components: {
    Flipbook,
    LeftIcon,
    RightIcon,
    PlusIcon,
    MinusIcon,
    DownloadIcon,
  },
  data: function () {
    return {
      page: 0,
      pages: [],
      pagesHiRes: [],
      hasMouse: true,
      pageNum: null,
    };
  },
  methods: {
    onFlipStart(page) {
      this.page = page;
      // return console.log('flip-left-start', page);
    },
    onFlipLeftEnd(page) {
      console.log("flip-left-end", page);
      return (window.location.hash = "#" + page);
    },
    onFlipRightStart(page) {
      return console.log("flip-right-start", page);
    },
    onFlipRightEnd(page) {
      console.log("flip-right-end", page);
      return (window.location.hash = "#" + page);
    },
    onZoomStart(zoom) {
      return console.log("zoom-start", zoom);
    },
    onZoomEnd(zoom) {
      return console.log("zoom-end", zoom);
    },
    // setPageFromHash(){
    //   var n;
    //   n = parseInt(window.location.hash.slice(1), 10);
    //   if (isFinite(n)) {
    //     return this.pageNum = n;
    //   }
    // }
  },
  mounted() {
    this.pages = [
      null,
      ...this.value.imageGallery.map((i) => i.imageURL + "&resize=550"),
    ];
    this.pagesHiRes = [null, ...this.value.imageGallery.map((i) => i.imageURL)];

    window.addEventListener(
      "keydown",
      (function (_this) {
        return function (ev) {
          var flipbook;
          flipbook = _this.$refs.flipbook;
          if (!flipbook) {
            return;
          }
          if (ev.keyCode === 37 && flipbook.canFlipLeft) {
            flipbook.flipLeft();
          }
          if (ev.keyCode === 39 && flipbook.canFlipRight) {
            return flipbook.flipRight();
          }
        };
      })(this)
    );
    // setTimeout(((function(_this) {
    //   return function() {
    //     _this.pages = [null, 'images/1.jpg', 'images/2.jpg', 'images/3.jpg', 'images/4.jpg', 'images/5.jpg', 'images/6.jpg'];
    //     return _this.pagesHiRes = [null, 'images-large/1.jpg', 'images-large/2.jpg', 'images-large/3.jpg', 'images-large/4.jpg', 'images-large/5.jpg', 'images-large/6.jpg'];
    //   };
    // })(this)), 1);
    // window.addEventListener('hashchange', this.setPageFromHash);
    // return this.setPageFromHash();
  },
};
</script>

<style>
.download {
  display: flex;
}
.seperator {
  width: 70px;
  text-align: center;
}
.comp {
  height: 750px;
}
.flipbook {
  width: 90%;
  max-width: 1200px;
  height: 680px;
  position: relative;
  margin: 0 auto;
}

a {
  color: inherit;
}
.action-bar {
  margin: 20px 0;
  width: 100%;
  height: 30px;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.action-bar .btn {
  font-size: 30px;
  color: #999;
}
.action-bar .btn svg {
  bottom: 0;
}
.action-bar .btn:not(:first-child) {
  margin-left: 10px;
}
.has-mouse .action-bar .btn:hover {
  color: #ccc;
  filter: drop-shadow(1px 1px 5px #000);
  cursor: pointer;
}
.action-bar .btn:active {
  filter: none !important;
}
.action-bar .btn.disabled {
  color: #666;
  pointer-events: none;
}
.action-bar .page-num {
  font-size: 12px;
  margin-left: 10px;
}
.flipbook .viewport {
  width: 90vw;
  height: calc(100vh - 50px - 40px);
}
.flipbook .bounding-box {
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
}
.flipbook.spine .bounding-box {
  background: linear-gradient(
    90deg,
    rgba(0, 0, 0, 0) 30%,
    rgba(0, 0, 0, 0.1) 49.6%,
    rgba(0, 0, 0, 0.19) 50%,
    rgba(0, 0, 0, 0.1) 50.4%,
    rgba(0, 0, 0, 0) 60%
  ) !important;
}
.credit {
  font-size: 12px;
  line-height: 20px;
  margin: 10px;
}

/* .page img::before{
  height: 100%;
  display: block;
  width: 100%;
  position: absolute;
  background-color: red; */
/* background: linear-gradient(90deg, rgba(0,0,0,0) 40%, rgba(0,0,0,0.1516981792717087) 50%, rgba(0,0,0,0) 60%) !important; */

/* .click-to-flip .right{
background: linear-gradient(90deg, rgba(0,0,0,0) 40%, rgba(0,0,0,0.1516981792717087) 50%, rgba(0,0,0,0) 60%) !important;

} */
@media screen and (min-width: 992px) {
  .btn.right {
    position: absolute;
    top: 50%;
    right: 0;
  }
  .btn.left {
    position: absolute;
    top: 50%;
    left: 0;
  }
}
</style>